"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), !function(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: !0,
        get: all[name]
    });
}(exports, {
    agentCountersChanged: function() {
        return agentCountersChanged;
    },
    default: function() {
        return _default;
    },
    getAgentCounters: function() {
        return getAgentCounters;
    }
});
const _agentkeepalive = function(obj, nodeInterop) {
    if (obj && obj.__esModule) return obj;
    if (null === obj || "object" != typeof obj && "function" != typeof obj) return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {
        __proto__: null
    }, hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if ("default" !== key && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        desc && (desc.get || desc.set) ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
    return newObj.default = obj, cache && cache.set(obj, newObj), newObj;
}(require("agentkeepalive"));
function _getRequireWildcardCache(nodeInterop) {
    if ("function" != typeof WeakMap) return null;
    var cacheBabelInterop = new WeakMap(), cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
const agentConfig = {
    maxSockets: 50,
    freeSocketTimeout: 25000
}, httpAgent = new _agentkeepalive.default(agentConfig), httpsAgent = new _agentkeepalive.HttpsAgent(agentConfig), _default = {
    httpAgent,
    httpsAgent
};
function getAgentCounters() {
    return httpsAgent.getCurrentStatus();
}
function agentCountersChanged() {
    return httpsAgent.statusChanged;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9odHRwL0F4aW9zTm9kZUNvbmZpZy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEh0dHBPcHRpb25zIH0gZnJvbSAnYWdlbnRrZWVwYWxpdmUnXG5pbXBvcnQgQWdlbnQsIHsgSHR0cHNBZ2VudCB9IGZyb20gJ2FnZW50a2VlcGFsaXZlJ1xuaW1wb3J0IHR5cGUgeyBBeGlvc1JlcXVlc3RDb25maWcgfSBmcm9tICdheGlvcydcblxuLyoqXG4gKiBVc2UgYSBzaGFyZWQgY29uZmlnIGZvciBIVFRQIGFuZCBIVFRQUy5cbiAqL1xuY29uc3QgYWdlbnRDb25maWc6IEh0dHBPcHRpb25zID0ge1xuICAgIG1heFNvY2tldHM6IDUwLFxuICAgIGZyZWVTb2NrZXRUaW1lb3V0OiAyNV8wMDAsXG59XG5cbi8qKlxuICogQ3JlYXRlIGdsb2JhbCBodHRwL2h0dHBzIGFnZW50cywgdXNlZCBieSBhbGwgQXhpb3MgaW5zdGFuY2VzLCB0byBlbnN1cmUgdGhhdCB0aGVyZSBpcyBhIHNpbmdsZVxuICogZ2xvYmFsIGNvbm5lY3Rpb24gcG9vbCwgd2l0aCBrZWVwLWFsaXZlIGVuYWJsZWQuXG4gKi9cbmNvbnN0IGh0dHBBZ2VudCA9IG5ldyBBZ2VudChhZ2VudENvbmZpZylcbmNvbnN0IGh0dHBzQWdlbnQgPSBuZXcgSHR0cHNBZ2VudChhZ2VudENvbmZpZylcblxuY29uc3Qgbm9kZUNvbmZpZzogQXhpb3NSZXF1ZXN0Q29uZmlnID0ge1xuICAgIGh0dHBBZ2VudCxcbiAgICBodHRwc0FnZW50LFxufVxuXG5leHBvcnQgZGVmYXVsdCBub2RlQ29uZmlnXG5cbi8qKlxuICogUmV0dXJucyBhbiBvYmplY3Qgd2l0aCBzdGF0dXMgYWJvdXQgdGhlIGFnZW50LiBXZSBvbmx5IGV4cG9zZSB0aGlzIGZvciB0aGUgSFRUUFMgYWdlbnQgY3VycmVudGx5LFxuICogdG8gc2ltcGxpZnkgdGhpbmdzLlxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0QWdlbnRDb3VudGVycygpOiBBZ2VudC5BZ2VudFN0YXR1cyB7XG4gICAgcmV0dXJuIGh0dHBzQWdlbnQuZ2V0Q3VycmVudFN0YXR1cygpXG59XG5cbi8qKlxuICogUmV0dXJucyB0cnVlIGlmIHRoZSBjb3VudGVycyBoYXZlIGNoYW5nZWQgc2luY2UgdGhlIGxhc3QgY2hlY2twb2ludC5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGFnZW50Q291bnRlcnNDaGFuZ2VkKCk6IGJvb2xlYW4ge1xuICAgIHJldHVybiBodHRwc0FnZW50LnN0YXR1c0NoYW5nZWRcbn1cbiJdLCJuYW1lcyI6WyJhZ2VudENvdW50ZXJzQ2hhbmdlZCIsImdldEFnZW50Q291bnRlcnMiLCJhZ2VudENvbmZpZyIsIm1heFNvY2tldHMiLCJmcmVlU29ja2V0VGltZW91dCIsImh0dHBBZ2VudCIsIkFnZW50IiwiaHR0cHNBZ2VudCIsIkh0dHBzQWdlbnQiLCJnZXRDdXJyZW50U3RhdHVzIiwic3RhdHVzQ2hhbmdlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0lBcUNnQkEsb0JBQW9CO2VBQXBCQTs7SUFiaEIsT0FBeUI7ZUFBekI7O0lBTWdCQyxnQkFBZ0I7ZUFBaEJBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7VUE3QmtCOzs7Ozs7OztBQU1sQyxNQUFNQyxjQUEyQjtJQUM3QkMsWUFBWTtJQUNaQyxtQkFBbUI7QUFDdkIsR0FNTUMsWUFBWSxJQUFJQyx1QkFBSyxDQUFDSixjQUN0QkssYUFBYSxJQUFJQywwQkFBVSxDQUFDTixjQU9sQyxXQUx1QztJQUNuQ0c7SUFDQUU7QUFDSjtBQVFPLFNBQVNOO0lBQ1osT0FBT00sV0FBV0UsZ0JBQWdCO0FBQ3RDO0FBS08sU0FBU1Q7SUFDWixPQUFPTyxXQUFXRyxhQUFhO0FBQ25DIn0=